import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const careviewItem = props.careviewItem;
  const setEditMode = props.setEditMode;

  const questionTitle = careviewItem.questionData.questionTitle;
  const questionOptions = careviewItem.questionData?.options || [];

  return (
    <Box
      sx={{
        '&:hover': {
          cursor: 'pointer',
        },
      }}
      onClick={setEditMode}
    >
      <Stack>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            <Translate
              expression='client.ClientDetail.CareviewSettings.Types.MultipleChoice.Question'
            />
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '16px',
            }}
          >
            {questionTitle}
          </Typography>
        </Box>
      </Stack>
      <Stack>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            <Translate
              expression='client.ClientDetail.CareviewSettings.Types.MultipleChoice.Options'
            />
          </Typography>
        </Box>
        <Box
        >
          {
            questionOptions.map((option, index) => {
              return (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '16px',
                      marginRight: '8px',
                    }}
                  >
                    {option.optionTitle}
                  </Typography>
                  {
                    option.followUp &&
                    <Typography
                      sx={{
                        fontSize: '16px',
                        fontStyle: 'italic',
                      }}
                    >
                      <Translate
                        expression='client.ClientDetail.CareviewSettings.Types.MultipleChoice.FollowupEnable'
                      />
                    </Typography>
                  }
                </Box>
              );
            })
          }
        </Box>
      </Stack>
    </Box>
  );
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
